export default {"src":"/_next/static/media/Logo_Rentennials_Top.a3da4f3d.svg","height":40,"width":185,"blurWidth":0,"blurHeight":0};